<template>
    <v-container max-width="1200">
        <v-card v-if="!showAdmin" class="pa-4 align-center justify-center">
            <v-card-title>Admin Login</v-card-title>

            <v-card-text>
                <v-text-field
                    v-model="email"
                    placeholder="Enter your email address"
                    prepend-inner-icon="mdi-email-outline"
                    variant="outlined"
                ></v-text-field>

                <v-text-field
                    v-model="password"
                    :append-inner-icon="passVisible ? 'mdi-eye-off' : 'mdi-eye'"
                    :type="passVisible ? 'text' : 'password'"
                    placeholder="Enter your password"
                    prepend-inner-icon="mdi-lock-outline"
                    variant="outlined"
                    @click:append-inner="passVisible = !passVisible"
                ></v-text-field>
                <v-btn
                    size="large"
                    variant="tonal"
                    block
                    @click="login"
                >
                    Log In
                </v-btn>
                <v-card-text v-if="errorMessage != ''">{{ errorMessage }}</v-card-text>
            </v-card-text>
        </v-card>
        <v-card v-else class="pa-4 align-center justify-center">
            <v-card-title>Admin Controls</v-card-title>

            <v-card-text>
                <v-card-title>Download Image Data</v-card-title>
                <v-row class="align-center">
                    <v-col cols="6" sm="6">
                        <v-date-input v-model="rangeImage" label="Select Range" multiple="range" @update:modelValue="downloadImageData" hide-details></v-date-input>
                    </v-col>
                    <v-col cols="6" sm="6">
                        <JsonCSV
                            :data="jsonImageData"
                            :name="filenameImage">
                        <v-btn
                            size="large"
                            variant="tonal"
                            :disabled="Object.keys(jsonImageData).length === 0">
                            Download .CSV File {{ resultsImage != null ? '(' + resultsImage + ' results)' : '' }}
                        </v-btn>
                    </JsonCSV>
                    </v-col>
                </v-row>

            </v-card-text>

            <v-card-text>
                <v-card-title>Download Survey Data</v-card-title>
                <v-row class="align-center">
                    <v-col cols="6" sm="6">
                        <v-date-input v-model="rangeSurvey" label="Select Range" multiple="range" @update:modelValue="downloadSurveyData" hide-details></v-date-input>
                    </v-col>
                    <v-col cols="6" sm="6">
                        <JsonCSV
                            :data="jsonSurveyData"
                            :name="filenameSurvey">
                            <v-btn
                                size="large"
                                variant="tonal"
                                :disabled="Object.keys(jsonSurveyData).length === 0">
                                Download .CSV File {{ resultsSurvey != null ? '(' + resultsSurvey + ' results)' : '' }}
                            </v-btn>
                        </JsonCSV>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios'
import { VDateInput } from 'vuetify/labs/VDateInput'
import JsonCSV from 'vue-json-csv'

export default {
    name: 'AdminPage',

    components: {
        VDateInput,
        JsonCSV,
    },

    data: () => ({
        email: '',
        password: '',
        passVisible: false,
        showAdmin: false,
        errorMessage: '',

        rangeImage: null,
        jsonImageData: [],
        filenameImage: "",
        resultsImage: null,

        rangeSurvey: null,
        jsonSurveyData: [],
        filenameSurvey: "",
        resultsSurvey: null,
    }),

    methods: {
        convertTier(tier) {
            switch(tier) {
                case "0":
                    return "Absent"
                case "1":
                    return "Subdued"
                case "2":
                    return "Engaging"
                case "3":
                    return "Vivid"
                case "4":
                    return "Brilliant"
            }
        },
        downloadImageData() {
            this.jsonImageData = []
            this.resultsImage = null
            let startDateImage = this.rangeImage[0].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            let endDateImage = this.rangeImage[this.rangeImage.length-1].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            this.filenameImage = "ImageData - " + startDateImage + " to " + endDateImage + ".csv"
            
            let data = {
                startDate: startDateImage,
                endDate: endDateImage,
            }

            axios.post('image_data', data)
            .then((resp) => {
                if (resp.data != null) {
                    this.jsonImageData = JSON.parse(JSON.stringify(resp.data))

                    // Convert numerical value of tier
                    for (var i = 0; i < this.jsonImageData.length; i++) { this.jsonImageData[i].tier = this.convertTier(this.jsonImageData[i].tier) }

                    this.resultsImage = resp.data.length
                }
                else {
                    this.resultsImage = 0
                }
            })
            .catch((resp) => {
                this.errorMessage = resp.response.data
            })
        },
        downloadSurveyData() {
            this.jsonSurveyData = []
            this.resultsSurvey = null
            let startDateSurvey = this.rangeSurvey[0].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            let endDateSurvey = this.rangeSurvey[this.rangeSurvey.length-1].toLocaleDateString("en-CA", {year: "numeric", month: "2-digit", day: "2-digit", })
            this.filenameSurvey = "SurveyData - " + startDateSurvey + " to " + endDateSurvey + ".csv"
            
            let data = {
                startDate: startDateSurvey,
                endDate: endDateSurvey,
            }

            axios.post('survey_data', data)
            .then((resp) => {
                if (resp.data != null) {
                    this.jsonSurveyData = JSON.parse(JSON.stringify(resp.data))

                    // Convert numerical value of tier
                    for (var i = 0; i < this.jsonSurveyData.length; i++) { this.jsonSurveyData[i].tier = this.convertTier(this.jsonSurveyData[i].tier) }

                    this.resultsSurvey = resp.data.length
                }
                else {
                    this.resultsSurvey= 0
                }
            })
            .catch((resp) => {
                this.errorMessage = resp.response.data
            })
        },
        login() {
            let data = {
                email: this.email,
                password: this.password
            }

            axios.post('login', data)
            .then(() => {
                this.showAdmin = true
            })
            .catch((resp) => {
                this.errorMessage = resp.response.data
            })
        }

    }

}
</script>
